<template>
  <div>
    <draggable
      v-model="items"
      draggable=".item-repeater"
      handle=".drag-handler"
    >
      <div
        v-for="(item, index) in items"
        :key="obterKey(item)"
        class="item-repeater linha-repeater pa-3 mb-5"
      >
        <div class="d-flex justify-space-between align-center mb-3">
          <v-spacer />

          <div class="d-flex align-center">
            <SGPIconComponent
              color="primary"
              class="mr-2 cursor-pointer"
              @click="remover(index)"
            >
              mdi-trash-can-outline
            </SGPIconComponent>

            <v-icon class="drag-handler">
              mdi-drag-vertical
            </v-icon>
          </div>
        </div>

        <slot
          name="item"
          :item="item"
          :index="index"
          :item-key="obterKey(item)"
          :remove="() => remover(index)"
        />
      </div>
    </draggable>

    <div class="pa-5 d-flex align-center justify-center">
      <SGPFormBotaoComponent
        fab
        x-small
        @click="adicionar"
      >
        <SGPIconComponent>
          mdi-plus
        </SGPIconComponent>
      </SGPFormBotaoComponent>
    </div>

    <div class="text-right mt-4">
      <SGPFormBotaoComponent
        class="text-capitalize"
        @click="enviar"
      >
        {{ buttonText }}
      </SGPFormBotaoComponent>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import cloneDeep from 'lodash/cloneDeep'

export default {
  name: 'ModosWebRepeaterComponent',

  components: {
    draggable
  },

  props: {
    value: {
      type: Array,
      default: () => []
    },

    itemDefault: {
      type: Object,
      required: true
    },

    minimoItens: {
      type: Number,
      default: 1
    },

    buttonText: {
      type: String,
      default: 'Enviar'
    }
  },

  data() {
    return {
      itemKeys: new WeakMap()
    }
  },

  created() {
    let proximoKey = 0

    this.obterKey = item => {
      if (!this.itemKeys.has(item)) {
        this.itemKeys.set(item, ++proximoKey)
      }

      return this.itemKeys.get(item)
    }
  },

  computed: {
    items: {
      get() {
        return this.value
      },

      set(valor) {
        this.$emit('input', valor)
      }
    }
  },

  mounted() {
    if (!this.items.length) {
      this.adicionar()
    }
  },

  methods: {
    clone(obj) {
      return cloneDeep(obj)
    },

    adicionar() {
      const lista = [
        ...this.items,
        this.clone(this.itemDefault)
      ]

      this.$emit('input', lista)
      this.$emit('adicionar')
    },

    remover(index) {
      if (this.items.length <= this.minimoItens) {
        return
      }

      const lista = [...this.items]

      lista.splice(index, 1)

      this.$emit('input', lista)
      this.$emit('remover', index)
    },

    enviar() {
      this.$emit(
        'enviar',
        this.clone(this.items)
      )
    }
  }
}
</script>

<style scoped lang="scss">
.linha-repeater {
  background: #f5f5f5;
  border: solid 1px #e0e0e0;
  border-radius: 8px;
  transition: all 0.4s;
}

.linha-repeater:hover {
  background: #eeeeee;
  border: solid 1px #bdbdbd;
}

.cursor-pointer {
  cursor: pointer;
}

.drag-handler {
  cursor: move;
}
</style>
